import React from 'react';
import { MoreHorizontal, LucideIcon } from 'lucide-react';
import { theme } from '../../../styles/theme';

interface MetricWidgetProps {
  title: string;
  icon: LucideIcon;
  value: string;
  change: string;
  status: 'success' | 'warning' | 'error';
  size: 'small' | 'medium';
  darkMode: boolean;
}

const MetricWidget: React.FC<MetricWidgetProps> = ({
  title,
  icon: Icon,
  value,
  change,
  status,
  size,
  darkMode,
}) => {
  return (
    <div
      className={`${size === 'medium' ? 'lg:col-span-2' : ''} rounded-xl p-6 transition-shadow hover:shadow-lg`}
      style={{
        backgroundColor: darkMode ? theme.colors.background.darkPaper : theme.colors.background.paper,
        boxShadow: theme.widget.boxShadow,
      }}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="p-2 rounded-lg" style={{
          backgroundColor: status === 'success' 
            ? theme.colors.status.success + '20'
            : status === 'warning'
            ? theme.colors.status.warning + '20'
            : theme.colors.status.error + '20',
          color: status === 'success' 
            ? theme.colors.status.success
            : status === 'warning'
            ? theme.colors.status.warning
            : theme.colors.status.error
        }}>
          <Icon className="w-5 h-5" />
        </div>
        <MoreHorizontal className="w-4 h-4 cursor-pointer" style={{ 
          color: theme.colors.text.secondary 
        }} />
      </div>
      <h3 className="text-sm font-medium mb-1" style={{ 
        color: theme.colors.text.secondary 
      }}>
        {title}
      </h3>
      <p className="text-2xl font-bold mb-2" style={{ 
        color: darkMode ? theme.colors.text.darkPrimary : theme.colors.text.primary 
      }}>
        {value}
      </p>
      <p className="text-xs" style={{ 
        color: status === 'success' 
          ? theme.colors.status.success 
          : status === 'warning'
          ? theme.colors.status.warning
          : theme.colors.status.error 
      }}>
        {change}
      </p>
    </div>
  );
};

export default MetricWidget;